import {type Node} from 'slate';
import {ReactEditor} from 'slate-react';

import {isInlineCommentMark} from '../plugins/inline-comment';
import {isParagraph} from '../plugins/ParagraphTypes';
import {type TextWithFormatting, type WBSlateElementType} from './types';

type DOMNodeType = globalThis.Node;

const DOMNode = globalThis.Node;

function isDOMNode(value: any): value is DOMNodeType {
  return value instanceof DOMNode;
}

export function hasEditableTarget(
  editor: ReactEditor,
  target: EventTarget | null
): target is DOMNodeType {
  return (
    isDOMNode(target) &&
    ReactEditor.hasDOMNode(editor, target, {editable: true})
  );
}

export function isTextWithComments(node: Node): boolean {
  return Object.keys(node).some(isInlineCommentMark);
}

export function isTextWithFormatting(node: Node): node is TextWithFormatting {
  return typeof (node as any).text === 'string';
}

export function isEmptySlateValue(value: WBSlateElementType[]): boolean {
  return value.every(isEmptyParagraph);
}

function isEmptyParagraph(element: WBSlateElementType): boolean {
  return isParagraph(element) && element.children.every(isEmptyTextNode);
}

function isEmptyTextNode(node: Node): boolean {
  return (
    `text` in node && typeof node.text === `string` && node.text.trim() === ``
  );
}
